import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-grouped-table',
  templateUrl: './grouped-table.component.html',
  styleUrls: ['./grouped-table.component.css']
})
export class GroupedTableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/common/GroupedTable/grouped-table.component.ts